import { Injectable } from '@angular/core';

const STORAGE_KEY = 'markdown-formatting-hint-hidden';
const HIDDEN_VALUE = '1';

@Injectable({ providedIn: 'root' })
export class MarkdownHintVisibilityService {
  isHidden(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === HIDDEN_VALUE;
    } catch {
      // localStorage unavailable (private mode, SSR, etc.) — treat as visible.
      return false;
    }
  }

  setHidden(hidden: boolean): void {
    try {
      if (hidden) {
        localStorage.setItem(STORAGE_KEY, HIDDEN_VALUE);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      // localStorage unavailable — selection won't persist across reloads.
    }
  }
}
